// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__N_YFB","productName":"Table_productName__3MTuq"};